import React , {Component} from 'react';

class SlideCard extends Component{

    render(){
        const { object } = this.props;
        return(
            <div className="item">
                <img src={object.pic} />
            </div>
        )
    }
}

export default SlideCard;